var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.425,
    height: 112.957,
    viewBox: "0 0 120.425 112.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "noun-home-5960435",
    d: "M148.024,119.938l-3.724,4.41a2.061,2.061,0,0,1-2.9.248L93.7,84.406a3.464,3.464,0,0,0-4.479,0L41.5,124.6a2.068,2.068,0,0,1-2.9-.248l-3.706-4.41a2.051,2.051,0,0,1,.242-2.9L91.028,69.951h0a.653.653,0,0,1,.861,0l55.892,47.087h0a2.07,2.07,0,0,1,.244,2.9ZM134.412,175.9V122.367L91.889,86.545a.653.653,0,0,0-.861,0L48.5,122.367V175.9a.532.532,0,0,0,.532.532H76.38V138.541a3.478,3.478,0,0,1,3.475-3.478h23.2a3.489,3.489,0,0,1,3.486,3.478v37.888h27.35a.532.532,0,0,0,.532-.532Zm-30.687.532H79.181V138.541a.677.677,0,0,1,.673-.665h23.2a.665.665,0,0,1,.673.665V176.43ZM121.407,74.217V91.156l13,10.951V74.217a.532.532,0,0,0-.532-.532H121.936a.532.532,0,0,0-.532.532Zm12.48-3.333H121.936a3.341,3.341,0,0,0-3.332,3.333V88.794L93.7,67.807a3.458,3.458,0,0,0-4.479,0L33.33,114.891a4.871,4.871,0,0,0-.584,6.855l3.716,4.408h0a4.866,4.866,0,0,0,6.85.586l2.384-2.01V175.9h0a3.342,3.342,0,0,0,3.337,3.341h84.854a3.333,3.333,0,0,0,3.325-3.334V124.731l2.384,2.01h0a4.88,4.88,0,0,0,6.861-.587l3.724-4.408h0a4.92,4.92,0,0,0,1.125-3.549,4.87,4.87,0,0,0-1.711-3.307l-12.37-10.42V74.218a3.326,3.326,0,0,0-3.338-3.333Z",
    transform: "translate(-31.25 -66.635)",
    fill: "#2c53bb",
    stroke: "#2c53bb",
    strokeWidth: 0.7,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ba48b13ced9a73d91e820b6da5ce0f96.svg";
export { ForwardRef as ReactComponent };